import { render } from "./active-controls.vue?vue&type=template&id=0dd9e278&scoped=true&ts=true"
import script from "./active-controls.vue?vue&type=script&lang=ts"
export * from "./active-controls.vue?vue&type=script&lang=ts"

import "./active-controls.vue?vue&type=style&index=0&id=0dd9e278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd9e278"]])

export default __exports__